/* istanbul ignore file */

export { ArticlePageHero as default } from "./ArticlePageHero";
